import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = '[data-quote-form]';
const PLUGIN_NAME = 'quoteForm';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "quote-form" */ "./quote-form"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/quote-form/index--split.js